//#region src/logContext.ts
let _ctx = null;
/**
* Set the backing tag context implementation.
* Called by nodeShim.initNode() or browserShim.initBrowser().
*/
function setTagContext(ctx) {
	_ctx = ctx;
}
/**
* Shared tag context for propagating log tags through async call chains.
* Must call initNode() or initBrowser() before use.
*/
const logTagContext = {
	getStore() {
		return _ctx?.getStore();
	},
	run(store, fn) {
		if (!_ctx) return fn();
		return _ctx.run(store, fn);
	}
};
/**
* Get the current tag context (returns empty array if none set).
*/
function getCurrentTags() {
	return logTagContext.getStore() ?? [];
}

//#endregion
export { getCurrentTags, logTagContext, setTagContext };
//# sourceMappingURL=logContext.js.map